export const is_dashboard_selected = (state) => state.ui_settings.dashboard_settings?.selected;
export const is_dashboard_events_selected = (state) => state.ui_settings.dashboard_settings?.events_selected;
